import angular from 'angular';

import CaptureKeysDirective, { selector } from './capture-keys.directive';

export default angular
    .module('application.directive.capture-keys', [])
    .directive(selector, CaptureKeysDirective);



// WEBPACK FOOTER //
// ./src/application/directive/capture-keys/index.js